export default `Province,Population
Anhui Province,59500510
Beijing Municipality,19612368
Chongqing Municipality,28846170
Fujian Province,36894216
Guangdong Province,104303132
Gansu Province,25575254
Guangxi Zhuang Autonomous Region,46026629
Guizhou Province,34746468
Henan Province,94023567
Hubei Province,57237740
Hebei Province,71854202
Hainan Province,9171300
Hong Kong Special Administrative Region,7061200
Heilongjiang Province,38312224
Hunan Province,65683722
Jilin Province,27462297
Jiangsu Province,78659903
Jiangxi Province,44567475
Liaoning Province,43746323
Macau Special Administrative Region,552300
Inner Mongolia Autonomous Region,24706321
Ningxia Hui Autonomous Region,6301350
Qinghai Province,5626722
Sichuan Province,80418200
Shandong Province,95793065
Shanghai Municipality,23019148
Shaanxi Province,37327378
Shanxi Province,35712111
Tianjin Municipality,12938224
Taiwan Province,23162123
Xinjiang Uyghur Autonomous Region,21813334
Tibet Autonomous Region,3002166
Yunnan Province,45966239
Zhejiang Province,54426891`